import React from "react";
import { ExternalLink } from "lucide-react";
import { VIP_DISCORD_TICKET_URL } from "@/components/vip-simulator/vipInvoiceExport";
import { normalizeSteamId, steamProfileUrl } from "@/lib/steamId";
import { useI18n } from "@/i18n/I18nProvider";
import SteamIdForm from "./SteamIdForm";

/**
 * Formulário de SteamID ou vista só de leitura quando já está configurada.
 * @param {{
 *   steamId?: string | null;
 *   saving?: boolean;
 *   onSave: (steamId: string) => Promise<{ ok: boolean; error?: string }>;
 *   compact?: boolean;
 * }} props
 */
export default function SteamIdBlock({ steamId, saving = false, onSave, compact = false }) {
    const { t } = useI18n();
    const configured = normalizeSteamId(steamId);

    if (configured) {
        const profileUrl = steamProfileUrl(configured);
        return (
            <div className={`zrs-steam-configured ${compact ? "zrs-steam-configured--compact" : ""}`}>
                <div className="zrs-steam-configured__status">
                    <span className="zrs-steam-configured__badge" aria-hidden>
                        ✓
                    </span>
                    <span>{t("auth.steam.configured")}</span>
                </div>
                <label className="zrs-steam-form__label" htmlFor="zrs-steam-id-readonly">
                    SteamID64
                </label>
                <input
                    id="zrs-steam-id-readonly"
                    className="zrs-steam-form__input zrs-steam-form__input--readonly"
                    value={configured}
                    readOnly
                    aria-readonly="true"
                />
                {profileUrl ? (
                    <a
                        href={profileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="zrs-steam-configured__profile-link"
                    >
                        {t("auth.steam.openProfile")}
                        <ExternalLink size={14} aria-hidden />
                    </a>
                ) : null}
                <p className="zrs-steam-notice">
                    {t("auth.steam.changeNotice")}{" "}
                    <a href={VIP_DISCORD_TICKET_URL} target="_blank" rel="noopener noreferrer">
                        {t("auth.steam.discordTicket")}
                    </a>
                    .
                </p>
            </div>
        );
    }

    return (
        <SteamIdForm
            initialValue={steamId ?? ""}
            saving={saving}
            onSave={onSave}
            compact={compact}
        />
    );
}
